import { useMemo } from "react";
import { calculateVehicleTransportPricing, DEFAULT_VEHICLETRANSPORT_PRICING_CONFIG, } from "../services/pricing.js";
export function useVehicleTransportPricing(input) {
    return useMemo(() => {
        const config = input.config || DEFAULT_VEHICLETRANSPORT_PRICING_CONFIG;
        return calculateVehicleTransportPricing({ ...input, config });
    }, [input.distanceMiles, input.isEnclosed, input.vehicleCount, input.needsConditionReport, input.config, input.minimums]);
}
//# sourceMappingURL=useVehicleTransportPricing.js.map